import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { ProgressbarLegend } from '~/modules/common/charts/dashboard';
import ResourcingLegend from './ResourcingLegend';

const LegendItem = ({
  classes,
  isProgressBarLegend,
  barType,
  ...otherProps
}) => {
  const { root, roundBar, legendItem, legendText, timeOffAllocation } = classes;

  const legendClasses = useMemo(
    () => ({
      root,
      roundBar,
      legendText,
      timeOffAllocation,
      rootLegend: classes[barType]
    }),
    [barType, classes, legendText, root, roundBar, timeOffAllocation]
  );

  return (
    <div className={legendItem}>
      {isProgressBarLegend ? (
        <ProgressbarLegend {...otherProps} />
      ) : (
        <ResourcingLegend classes={legendClasses} {...otherProps} />
      )}
    </div>
  );
};

LegendItem.propTypes = {
  classes: PropTypes.object,
  isProgressBarLegend: PropTypes.bool,
  barType: PropTypes.oneOf(['dashedBar', 'roundBar', 'squareBar'])
};

export default LegendItem;
